module.exports = __webpack_public_path__ + "cceebfbd52f441270ef14c0c4f1cd081.png";